<template>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th>ID</th>
        <th>Time</th>
        <th>User</th>
        <th>File</th>
        <th>Status</th>
        <th>Notes</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="upload in uploads" :class="[{'text-danger': upload.errorMsg}, {'bg-warning': upload.status !== 'success' && upload.status !== 'failed'}]">
        <td>{{ upload.id }}</td>
        <td>{{ upload.uploadTime }}</td>
        <td>{{ upload.user.name }}</td>
        <td>{{ upload.filename }}</td>
        <td>{{ upload.status }}</td>
        <td style="white-space: pre;">{{ upload.errorMsg }}</td>
      </tr>
    </tbody>

  </table>
</template>


<script>
export default {
  props: ['uploads'],
}
</script>



// WEBPACK FOOTER //
// src/-service-app/components/tables/UploadsTable.vue